// extracted by mini-css-extract-plugin
export default {"iconWrapper":"footer-module--icon-wrapper--2cqz6"};